/* istanbul ignore file */

export { Tabs as default } from "./Tabs";
